import dayjs from "dayjs";
import { ViewValueType } from "src/state/_types";
import { prettyRecurrence } from "src/utils/objects";
import { capitalizeWords } from "src/utils/string";
import { Anchor, Group, Text } from "@mantine/core";
import { Icon } from "@iconify/react";
import { makeEnumBadgeComponent } from "../ui/Badges";
import { Booking_Type_Enum, Tenant_Status_Enum, Tenant_Type_Enum } from "src/state/gql/_types";
import { BOOKING_TYPE_ENUM_PALETTE, TENANT_STATUS_ENUM_PALETTE, TENANT_TYPE_ENUM_PALETTE } from "src/state/palettes";

const TenantStatusBadge = makeEnumBadgeComponent(Tenant_Status_Enum,'filled','lg', TENANT_STATUS_ENUM_PALETTE)
const TenantTypeBadge = makeEnumBadgeComponent(Tenant_Type_Enum,'outline','lg', TENANT_TYPE_ENUM_PALETTE)
const BookingTypeBadge = makeEnumBadgeComponent(Booking_Type_Enum,'outline','lg', BOOKING_TYPE_ENUM_PALETTE)

type ValueProps = {
    type: ViewValueType;
    value: string | number | boolean | null | undefined;
    format?: string;
    relation_field?: string | null;
    relation?: {
        [key: string]: string | number | boolean | null | undefined;
    }
};

export function Value({ type, value, format, relation_field = null, relation }: ValueProps) {
    if (value == null || value === "") return <Text size="sm" c="var(--mantine-color-gray-3)">-</Text>;
    switch (type) { 
        case "boolean":
            return value ? "Yes" : "No";
        case "number":
            return Number(value).toLocaleString();
        case "currency":
            return new Intl.NumberFormat(undefined, { style: "currency", currency: "USD" }).format(Number(value));
        case "date":
            return dayjs(value as string).format(format || "M/D/YY");
        case "datetime":
            return dayjs(value as string).format(format || "M/D/YY h:mm A");
        case "time":
            return dayjs(value as string, ["HH:mm:ss", "HH:mm"]).format(format || "h:mm A");
        case "rrule":
            return capitalizeWords(prettyRecurrence(value as string));
        case "multi-select":
            return !!value && typeof value == 'string' ? (value as string).split(',').join(', ') : '';
        case "calendar-link":
            return (
                <Anchor href={value as string} target="_blank" rel="noopener noreferrer" size="sm">
                    <Group gap={6} wrap="nowrap">
                        <Icon icon="ph:calendar-blank-duotone" width={16} />
                        <span style={{ fontWeight: 600 }}>iCal Feed</span>
                        <Icon icon="ph:arrow-square-out" width={14} />
                    </Group>
                </Anchor>
            );
        case "tenant-status-badge":
            return <TenantStatusBadge status={{ value: relation?.value as string, display: relation?.display as string, relation_field: relation_field as string }} />;
        case "tenant-type-badge":
            return <TenantTypeBadge status={{ value: relation?.value as string, display: relation?.display as string, relation_field: relation_field as string }} />;
        case "booking-type-badge":
            return <BookingTypeBadge status={{ value: relation?.value as string, display: relation?.display as string, relation_field: relation_field as string }} />;
        default:
            return String(value);
    }

}